webpackJsonp([173894859265406],{

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactstrap = __webpack_require__(32);
	
	__webpack_require__(344);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ButtonVoirTous = function ButtonVoirTous(props) {
	  return _react2.default.createElement(
	    _reactstrap.Button,
	    { onClick: props.onClick ? function () {
	        return props.onClick();
	      } : undefined },
	    props.voirTous
	  );
	};
	
	ButtonVoirTous.propTypes = {
	  onClick: _propTypes2.default.func,
	  voirTous: _propTypes2.default.string
	};
	
	exports.default = ButtonVoirTous;
	module.exports = exports['default'];

/***/ }),

/***/ 344:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(25);
	
	var _reactstrap = __webpack_require__(32);
	
	__webpack_require__(151);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Card = function Card(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'card-offshore' },
	    _react2.default.createElement(
	      'i',
	      { className: 'material-icons' },
	      props.icon
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'card-offshore-title' },
	      props.title
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'card-offshore-body' },
	      props.children
	    ),
	    _react2.default.createElement(
	      _reactstrap.Button,
	      { onClick: function onClick() {
	          return (0, _gatsbyLink.navigateTo)(props.link);
	        } },
	      'En savoir plus'
	    )
	  );
	};
	
	Card.propTypes = {
	  icon: _propTypes2.default.string,
	  title: _propTypes2.default.string,
	  children: _propTypes2.default.object
	};
	
	exports.default = Card;
	module.exports = exports['default'];

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(151);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CardsBanner = function CardsBanner(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'cards-banner' },
	    props.children
	  );
	};
	
	CardsBanner.propTypes = {
	  children: _propTypes2.default.object
	};
	
	exports.default = CardsBanner;
	module.exports = exports['default'];

/***/ }),

/***/ 151:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyImage = __webpack_require__(18);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactMedia = __webpack_require__(21);
	
	var _reactMedia2 = _interopRequireDefault(_reactMedia);
	
	var _ui = __webpack_require__(107);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeroBanner = function HeroBanner(props) {
	  var heroBannerTexte = props.heroBannerTexte,
	      enSavoirPlus = props.enSavoirPlus,
	      heroImage = props.heroImage,
	      heroImageSmall = props.heroImageSmall,
	      link = props.link;
	
	
	  return _react2.default.createElement(
	    _ui.Jumbotron,
	    {
	      title: 'Offshore Services',
	      subtitle: heroBannerTexte,
	      buttonText: enSavoirPlus,
	      link: link
	    },
	    _react2.default.createElement(
	      _reactMedia2.default,
	      { query: { minWidth: '768px' } },
	      function (matches) {
	        return matches ?
	        // si plus grand que 768px =>
	        _react2.default.createElement(_gatsbyImage2.default, { alt: heroImage.title, sizes: heroImage.sizes }) : _react2.default.createElement(_gatsbyImage2.default, { alt: heroImageSmall.title, sizes: heroImageSmall.sizes });
	      }
	    )
	  );
	};
	
	HeroBanner.propTypes = {
	  heroBannerTexte: _propTypes2.default.string,
	  enSavoirPlus: _propTypes2.default.string,
	  heroImage: _propTypes2.default.object,
	  heroImageSmall: _propTypes2.default.object
	};
	
	exports.default = HeroBanner;
	module.exports = exports['default'];

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyImage = __webpack_require__(18);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactMedia = __webpack_require__(21);
	
	var _reactMedia2 = _interopRequireDefault(_reactMedia);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeroPhoto = function HeroPhoto(props) {
	  var heroPhoto = props.heroPhoto,
	      heroPhotoSmall = props.heroPhotoSmall;
	
	  return _react2.default.createElement(
	    _reactMedia2.default,
	    { query: { minWidth: '768px' } },
	    function (matches) {
	      return matches ?
	      // si plus grand que 768px =>
	      _react2.default.createElement(_gatsbyImage2.default, { alt: heroPhoto.title, sizes: heroPhoto.sizes }) : _react2.default.createElement(_gatsbyImage2.default, { alt: heroPhotoSmall.title, sizes: heroPhotoSmall.sizes });
	    }
	  );
	};
	
	HeroPhoto.propTypes = {
	  heroPhoto: _propTypes2.default.object.isRequired,
	  heroPhotoSmall: _propTypes2.default.object.isRequired
	};
	
	exports.default = HeroPhoto;
	module.exports = exports['default'];

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(345);
	
	var _PostCard = __webpack_require__(105);
	
	var _PostCard2 = _interopRequireDefault(_PostCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LatestBlogBanner = function LatestBlogBanner(props) {
	  var blogBannerTitle = props.blogBannerTitle;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'latest-blog-banner' },
	    _react2.default.createElement(
	      'h1',
	      null,
	      blogBannerTitle
	    ),
	    props.children
	  );
	};
	
	LatestBlogBanner.propTypes = {
	  blogBannerTitle: _propTypes2.default.string,
	  children: _propTypes2.default.object
	};
	
	exports.default = LatestBlogBanner;
	module.exports = exports['default'];

/***/ }),

/***/ 345:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyImage = __webpack_require__(18);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactMedia = __webpack_require__(21);
	
	var _reactMedia2 = _interopRequireDefault(_reactMedia);
	
	__webpack_require__(346);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NosMarques = function NosMarques(props) {
	  var marquesBannerTitle = props.marquesBannerTitle,
	      logosMarquesFull = props.logosMarquesFull,
	      logosMarquesSmall = props.logosMarquesSmall,
	      marquesBannerBody = props.marquesBannerBody;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: (props.className || '') + ' nos-marques' },
	    _react2.default.createElement(
	      'h1',
	      null,
	      marquesBannerTitle
	    ),
	    _react2.default.createElement(
	      _reactMedia2.default,
	      { query: { minWidth: '768px' } },
	      function (matches) {
	        return matches ?
	        // si plus grand que 768px =>
	        _react2.default.createElement(
	          'div',
	          { className: 'brand-logos' },
	          _react2.default.createElement(_gatsbyImage2.default, {
	            alt: logosMarquesFull.title,
	            sizes: logosMarquesFull.sizes
	          })
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'brand-logos' },
	          _react2.default.createElement(_gatsbyImage2.default, {
	            alt: logosMarquesSmall.title,
	            sizes: logosMarquesSmall.sizes
	          })
	        );
	      }
	    ),
	    _react2.default.createElement('div', {
	      className: 'nos-marques-text',
	      dangerouslySetInnerHTML: { __html: marquesBannerBody }
	    })
	  );
	};
	
	NosMarques.propTypes = {
	  className: _propTypes2.default.string,
	  marquesBannerTitle: _propTypes2.default.string,
	  logosMarquesFull: _propTypes2.default.object,
	  logosMarquesSmall: _propTypes2.default.object,
	  marquesBannerBody: _propTypes2.default.string
	};
	
	exports.default = NosMarques;
	module.exports = exports['default'];

/***/ }),

/***/ 346:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyImage = __webpack_require__(18);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gatsbyLink = __webpack_require__(25);
	
	var _reactstrap = __webpack_require__(32);
	
	__webpack_require__(347);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PostCard = function PostCard(props) {
	  var blogPost = props.blogPost.node;
	  var transformedPost = blogPost.childContentfulBlogPostPostTextNode.childMarkdownRemark;
	  var excerpt = transformedPost.excerpt;
	  var _blogPost$heroPhoto = blogPost.heroPhoto,
	      title = _blogPost$heroPhoto.title,
	      sizes = _blogPost$heroPhoto.sizes;
	
	
	  var link = '/' + blogPost.node_locale + '/blog/' + blogPost.slug;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'post-card' },
	    _react2.default.createElement(
	      'div',
	      { onClick: function onClick() {
	          return (0, _gatsbyLink.navigateTo)(link);
	        } },
	      _react2.default.createElement(_gatsbyImage2.default, { alt: title, sizes: sizes })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'text-muted' },
	      blogPost.date
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'text-muted' },
	      transformedPost.timeToRead,
	      ' ',
	      props.timeToRead
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      blogPost.title
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      excerpt
	    ),
	    _react2.default.createElement(
	      _reactstrap.Button,
	      { onClick: function onClick() {
	          return (0, _gatsbyLink.navigateTo)(link);
	        }, color: 'secondary' },
	      props.lireArticle
	    )
	  );
	};
	
	PostCard.propTypes = {
	  blogPost: _propTypes2.default.object.isRequired,
	  timeToRead: _propTypes2.default.string.isRequired,
	  lireArticle: _propTypes2.default.string.isRequired
	};
	
	exports.default = PostCard;
	module.exports = exports['default'];

/***/ }),

/***/ 347:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyImage = __webpack_require__(18);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _ImgCarousel = __webpack_require__(233);
	
	var _ImgCarousel2 = _interopRequireDefault(_ImgCarousel);
	
	__webpack_require__(348);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuiSommesNousBanner = function QuiSommesNousBanner(props) {
	  var carouselImages = props.carouselImages,
	      aboutBannerTitle = props.aboutBannerTitle,
	      aboutBannerBody = props.aboutBannerBody;
	  //! Attention : Il faut absolument que les images aient les mêmes dimensions.
	  //! A gérer dans Contentful directement
	
	  return _react2.default.createElement(
	    'div',
	    { className: (props.className || '') + ' offshore-about' },
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-6' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          aboutBannerTitle
	        ),
	        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: aboutBannerBody } })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-6' },
	        _react2.default.createElement(_ImgCarousel2.default, { images: carouselImages })
	      )
	    )
	  );
	};
	
	QuiSommesNousBanner.propTypes = {
	  className: _propTypes2.default.string,
	  carouselImages: _propTypes2.default.array,
	  aboutBannerTitle: _propTypes2.default.string,
	  aboutBannerBody: _propTypes2.default.string
	};
	
	exports.default = QuiSommesNousBanner;
	module.exports = exports['default'];

/***/ }),

/***/ 348:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ButtonVoirTous = exports.PostCard = exports.LatestBlogBanner = exports.QuiSommesNousBanner = exports.HeroPhoto = exports.NosMarques = exports.Card = exports.CardsBanner = exports.HeroBanner = undefined;
	
	var _HeroBanner = __webpack_require__(218);
	
	var _HeroBanner2 = _interopRequireDefault(_HeroBanner);
	
	var _CardsBanner = __webpack_require__(217);
	
	var _CardsBanner2 = _interopRequireDefault(_CardsBanner);
	
	var _Card = __webpack_require__(216);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _NosMarques = __webpack_require__(221);
	
	var _NosMarques2 = _interopRequireDefault(_NosMarques);
	
	var _HeroPhoto = __webpack_require__(219);
	
	var _HeroPhoto2 = _interopRequireDefault(_HeroPhoto);
	
	var _QuiSommesNousBanner = __webpack_require__(222);
	
	var _QuiSommesNousBanner2 = _interopRequireDefault(_QuiSommesNousBanner);
	
	var _LatestBlogBanner = __webpack_require__(220);
	
	var _LatestBlogBanner2 = _interopRequireDefault(_LatestBlogBanner);
	
	var _PostCard = __webpack_require__(105);
	
	var _PostCard2 = _interopRequireDefault(_PostCard);
	
	var _ButtonVoirTous = __webpack_require__(215);
	
	var _ButtonVoirTous2 = _interopRequireDefault(_ButtonVoirTous);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.HeroBanner = _HeroBanner2.default;
	exports.CardsBanner = _CardsBanner2.default;
	exports.Card = _Card2.default;
	exports.NosMarques = _NosMarques2.default;
	exports.HeroPhoto = _HeroPhoto2.default;
	exports.QuiSommesNousBanner = _QuiSommesNousBanner2.default;
	exports.LatestBlogBanner = _LatestBlogBanner2.default;
	exports.PostCard = _PostCard2.default;
	exports.ButtonVoirTous = _ButtonVoirTous2.default;

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(25);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(36);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _index = __webpack_require__(223);
	
	var _ContactUs = __webpack_require__(50);
	
	var _ContactUs2 = _interopRequireDefault(_ContactUs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Home = function Home(props) {
	  var data = props.data,
	      blogPosts = props.blogPosts;
	
	
	  var hreflang = data.node_locale === 'fr' ? 'en' : 'fr';
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement('html', { lang: data.node_locale }),
	      _react2.default.createElement(
	        'title',
	        null,
	        data.title
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: data.description }),
	      _react2.default.createElement('link', {
	        rel: 'alternate',
	        hreflang: hreflang,
	        href: 'https://www.offshoreservices.fr/' + hreflang + '/'
	      })
	    ),
	    _react2.default.createElement(_index.HeroBanner, {
	      heroBannerTexte: data.heroBannerTexte.heroBannerTexte,
	      heroImage: data.heroImage,
	      heroImageSmall: data.heroImageSmall,
	      enSavoirPlus: data.enSavoirPlus.enSavoirPlus,
	      link: '/' + data.node_locale + '/about'
	    }),
	    _react2.default.createElement(_index.NosMarques, {
	      className: 'container',
	      marquesBannerTitle: data.marquesBannerTitle.marquesBannerTitle,
	      logosMarquesFull: data.logosMarquesFull,
	      logosMarquesSmall: data.logosMarquesSmall,
	      marquesBannerBody: data.marquesBannerBody.childMarkdownRemark.html
	    }),
	    _react2.default.createElement(_index.HeroPhoto, {
	      heroPhoto: data.heroPhoto,
	      heroPhotoSmall: data.heroPhotoSmall
	    }),
	    _react2.default.createElement(
	      _index.CardsBanner,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement('div', {
	          dangerouslySetInnerHTML: {
	            __html: data.servicesBannerTitle.childMarkdownRemark.html
	          }
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-4' },
	            _react2.default.createElement(
	              _index.Card,
	              {
	                icon: 'build',
	                title: data.cardVenteTitle.cardVenteTitle,
	                link: '/' + data.node_locale + '/services'
	              },
	              _react2.default.createElement('div', {
	                dangerouslySetInnerHTML: {
	                  __html: data.cardVenteBody.childMarkdownRemark.html
	                }
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-4' },
	            _react2.default.createElement(
	              _index.Card,
	              {
	                icon: 'directions_boat',
	                title: data.cardInstallTitle.cardInstallTitle,
	                link: '/' + data.node_locale + '/services'
	              },
	              _react2.default.createElement('div', {
	                dangerouslySetInnerHTML: {
	                  __html: data.cardInstallBody.childMarkdownRemark.html
	                }
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-4' },
	            _react2.default.createElement(
	              _index.Card,
	              {
	                icon: 'verified_user',
	                title: data.cardAnalysesTitle.cardAnalysesTitle,
	                link: '/' + data.node_locale + '/services'
	              },
	              _react2.default.createElement('div', {
	                dangerouslySetInnerHTML: {
	                  __html: data.cardAnalysesBody.childMarkdownRemark.html
	                }
	              })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_index.QuiSommesNousBanner, {
	      className: 'container',
	      carouselImages: data.carouselImages,
	      aboutBannerTitle: data.aboutBannerTitle.aboutBannerTitle,
	      aboutBannerBody: data.aboutBannerBody.childMarkdownRemark.html
	    }),
	    _react2.default.createElement(
	      _index.LatestBlogBanner,
	      { blogBannerTitle: data.blogBannerTitle.blogBannerTitle },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          blogPosts && blogPosts.map(function (blogPost, i) {
	            return _react2.default.createElement(
	              'div',
	              { key: i, className: 'col-md-4' },
	              _react2.default.createElement(_index.PostCard, {
	                blogPost: blogPost,
	                timeToRead: data.timeToRead,
	                lireArticle: data.lireArticle
	              })
	            );
	          })
	        ),
	        _react2.default.createElement(
	          'center',
	          { className: 'blog-button' },
	          _react2.default.createElement(_index.ButtonVoirTous, {
	            onClick: function onClick() {
	              return (0, _gatsbyLink.navigateTo)('/' + data.node_locale + '/blog');
	            },
	            voirTous: data.voirTous
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(_ContactUs2.default, { locale: data.node_locale })
	  );
	};
	
	Home.propTypes = {
	  data: _propTypes2.default.object,
	  blogPosts: _propTypes2.default.array
	};
	
	exports.default = Home;
	module.exports = exports['default'];

/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.enHomeQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Home = __webpack_require__(231);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(props) {
	  var data = props.data.allContentfulAccueil.edges[0].node;
	  var blogPosts = props.data.allContentfulBlogPost.edges;
	
	  return _react2.default.createElement(_Home2.default, { data: data, blogPosts: blogPosts });
	};
	
	exports.default = IndexPage;
	
	
	IndexPage.propTypes = {
	  data: _propTypes2.default.object
	};
	
	var enHomeQuery = exports.enHomeQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-en-js-7b4cebdbda07a8c0f639.js